/*
  WIP
  `resize: vertical` added as character count is currently not responsive with horizontal resize.
  if horizontal resize is a priority, restructure or relocate character count outside of textarea.
*/

import React from 'react';
import classnames from 'classnames';

import ErrorWrapper from 'dpl/form/components/ErrorWrapper';

export type TextAreaProps = Omit<
  React.TextareaHTMLAttributes<HTMLTextAreaElement>,
  'onChange' | 'value' | 'maxLength' | 'name'
> & {
  displayErrors?: boolean;
  errors?: React.ReactNode[];
  label?: string;
  labelClassName?: string;
  maxLength?: number | null;
  name: string;
  noResize?: boolean;
  onChange?: ((e: React.ChangeEvent<HTMLTextAreaElement>) => void) | null;
  value?: string | null;
};

function TextArea({
  disabled = false,
  displayErrors = false,
  errors = [],
  id,
  label,
  labelClassName = 'font-12',
  maxLength,
  name,
  noResize = false,
  onChange,
  required = false,
  value,
  ...textareaProps
}: TextAreaProps): React.ReactElement {
  const classes = classnames(
    'w-100 pt3 pb7 ph4 ba br3 b--default bg-white input-reset secondary',
    {
      'no-resize': noResize,
      'disabled bg-subtle-light-gray b--gray-300 no-focus-border': disabled
    }
  );

  const textareaValue = value || '';

  const textAreaLabel = (
    <label
      className={classnames('DSTextArea--label', labelClassName)}
      htmlFor={id}
    >
      <span
        className={classnames('dib secondary mb2', {
          disabled
        })}
      >
        {label}
      </span>
    </label>
  );

  return (
    <div className="DSTextArea">
      {label && (
        <div className="flex justify-between">
          {textAreaLabel}
          {required && <p className="font-12 self-center rubber">Required</p>}
        </div>
      )}
      <ErrorWrapper isShown={displayErrors} errors={errors}>
        <div className="flex relative font-16">
          <textarea
            className={classes}
            id={id}
            name={name}
            onChange={onChange ?? undefined}
            value={textareaValue}
            style={{ resize: noResize ? undefined : 'vertical' }}
            maxLength={
              maxLength != null && maxLength > 0 ? maxLength : undefined
            }
            {...textareaProps}
          />
          {maxLength != null && maxLength > 0 && (
            <div
              className="w-100 absolute tr pointer-events-none"
              style={{ bottom: '1px' }}
            >
              <span
                className={classnames('db bg-white mh4 pv1 font-12 disabled', {
                  'bg-subtle-light-gray': disabled
                })}
              >
                {textareaValue.length}/{maxLength}
              </span>
            </div>
          )}
        </div>
      </ErrorWrapper>
    </div>
  );
}

export default TextArea;
